export const BG_URL =
  'url("https://res.cloudinary.com/appbuilder/image/fetch/c_fill,g_auto,f_auto/https://app-designer-stg.hpcloud.hp.com/form/553/links/7716/File/Image20220527160251%20(1).jpg")'
